/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

// require('./bootstrap');

// global.$ = global.jQuery = require('jquery');
window.Pusher = require('pusher-js');
import Echo from 'laravel-echo';
// window._ = require('lodash');

if (loggedIn) {
    try {
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: 'app-key',
            // forceTLS: document.location.protocol == 'https:',
            forceTLS: true,
            encrypted: true,
            cluster: 'mt1',
            wsHost: document.location.hostname,
            wsPort: document.location.port ? parseInt(document.location.port, 10) : 80,
            wssPort: document.location.port ? parseInt(document.location.port, 10) : 443,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
        });
    } catch (exception) {
        console.error(exception);
    }

}
